"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module ShineProducts
 *
 */
var uniq = require('lodash/uniq');

var getMatchingConstructor = require('./utils/getMatchingConstructor');

var Component = require('./interfaces/Component');

var components = require('./components');

var Product = require('./interfaces/Product');

var embellishments = require('./embellishments/constants');

var envelopes = require('./envelopes/constants');

var invitation_suites = require('./invitation_suites/constants');

var prewedding_stationery = require('./prewedding_stationery/constants');

var sample_sets = require('./sample_sets/constants');

var samples = require('./samples/constants');

var wedding_day_stationery = require('./wedding_day_stationery/constants');

var wedding_programs = require('./wedding_programs/constants');

var constants = require('./constants');

var categories = {
  embellishments: embellishments,
  envelopes: envelopes,
  invitation_suites: invitation_suites,
  prewedding_stationery: prewedding_stationery,
  sample_sets: sample_sets,
  samples: samples,
  wedding_day_stationery: wedding_day_stationery,
  wedding_programs: wedding_programs
};

var _require = require('./utils'),
    extractProperties = _require.extractProperties,
    convertFromVersionZero = _require.convertFromVersionZero,
    generateQuantityOptions = _require.generateQuantityOptions,
    createShineProductFromEtsyTransaction = _require.createShineProductFromEtsyTransaction,
    parseProductTypeFromEtsyTransaction = _require.parseProductTypeFromEtsyTransaction,
    handleConvertProduct = _require.handleConvertProduct,
    parcelPostRequiredFn = _require.parcelPostRequiredFn,
    oddPostageRequiredFn = _require.oddPostageRequiredFn;
/**
 * returns true if each key-value pair in filters{} exists in opt{}
 * @param {*} opt - an option
 * @param {*} filters - a set of key-value pairs to filter out options
 */


function filterer(opt, filters) {
  return Object.keys(filters).map(function (key) {
    return opt[key] === filters[key];
  }).every(function (a) {
    return a;
  });
}

var defaultOptions = {
  linerStyles: [],
  colors: []
}; // these will put shortcut make() methods on the singleton, below.
// e.g. ShineProducts.instance().classicInvitationSuite.make();
// same as ShineProducts.instance().make({ product_type: constants.CLASSIC_WEDDING_INVITATIONS });

var constructors = {
  customSamples: constants.CUSTOM_SAMPLES,
  classicInvitationSuite: constants.CLASSIC_WEDDING_INVITATIONS,
  classicInvitationSuiteReprints: constants.CLASSIC_WEDDING_INVITATION_REPRINTS,
  sampleClassicInvitationSuite: constants.SAMPLE_CLASSIC_INVITATION_SUITES,
  ribbonInvitationSuite: constants.RIBBON_WEDDING_INVITATIONS,
  ribbonInvitationSuiteReprints: constants.RIBBON_WEDDING_INVITATION_REPRINTS,
  floralInvitationSuite: constants.FLORAL_WEDDING_INVITATIONS,
  floralInvitationSuiteReprints: constants.FLORAL_WEDDING_INVITATION_REPRINTS,
  vellumInvitationSuite: constants.VELLUM_WEDDING_INVITATIONS,
  vellumInvitationSuiteReprints: constants.VELLUM_WEDDING_INVITATION_REPRINTS,
  flatInvitationSuiteReprintsCovid: constants.FLAT_WEDDING_INVITATION_REPRINTS_COVID,
  letterpressInvitationSuite: constants.LETTERPRESS_WEDDING_INVITATIONS,
  letterpressInvitationSuiteReprints: constants.LETTERPRESS_WEDDING_INVITATION_REPRINTS,
  letterpressInvitationSuiteReprintsCovid: constants.LETTERPRESS_WEDDING_INVITATION_REPRINTS_COVID,
  envelopes: constants.ENVELOPES,
  envelopeReprints: constants.ENVELOPE_REPRINTS,
  letterpressSaveTheDates: constants.LETTERPRESS_SAVE_THE_DATES,
  letterpressSaveTheDatesReprints: constants.LETTERPRESS_SAVE_THE_DATE_REPRINTS,
  saveTheDates: constants.SAVE_THE_DATES,
  saveTheDatesReprints: constants.SAVE_THE_DATE_REPRINTS,
  photoSaveTheDates: constants.PHOTO_SAVE_THE_DATES,
  photoSaveTheDatesReprints: constants.PHOTO_SAVE_THE_DATE_REPRINTS,
  thankYouCards: constants.THANK_YOU_CARDS,
  thankYouCardsReprints: constants.THANK_YOU_CARD_REPRINTS,
  squareWeddingPrograms: constants.SQUARE_WEDDING_PROGRAMS,
  squareWeddingProgramsReprints: constants.SQUARE_WEDDING_PROGRAM_REPRINTS,
  basicBookletWeddingPrograms: constants.BASIC_BOOKLET_WEDDING_PROGRAMS,
  basicBookletWeddingProgramsReprints: constants.BASIC_BOOKLET_WEDDING_PROGRAM_REPRINTS,
  deluxeBookletWeddingPrograms: constants.DELUXE_BOOKLET_WEDDING_PROGRAMS,
  deluxeBookletWeddingProgramsReprints: constants.DELUXE_BOOKLET_WEDDING_PROGRAM_REPRINTS,
  flatBookletWeddingPrograms: constants.FLAT_BOOKLET_WEDDING_PROGRAMS,
  flatBookletWeddingProgramsReprints: constants.FLAT_BOOKLET_WEDDING_PROGRAM_REPRINTS,
  customSigns: constants.CUSTOM_SIGNS,
  customSignsReprints: constants.CUSTOM_SIGN_REPRINTS,
  favorTags: constants.FAVOR_TAGS,
  favorTagsReprints: constants.FAVOR_TAG_REPRINTS,
  placeCards: constants.PLACE_CARDS,
  placeCardsReprints: constants.PLACE_CARD_REPRINTS,
  reservedSigns: constants.RESERVED_SIGNS,
  reservedSignsReprints: constants.RESERVED_SIGN_REPRINTS,
  seatingCharts: constants.SEATING_CHARTS,
  seatingChartsReprints: constants.SEATING_CHART_REPRINTS,
  tableNumbers: constants.TABLE_NUMBERS,
  tableNumbersReprints: constants.TABLE_NUMBER_REPRINTS,
  weddingMenus: constants.WEDDING_MENUS,
  weddingMenusReprints: constants.WEDDING_MENU_REPRINTS,
  letterpressWeddingMenus: constants.LETTERPRESS_WEDDING_MENUS,
  letterpressWeddingMenuReprints: constants.LETTERPRESS_WEDDING_MENU_REPRINTS,
  weddingSigns: constants.WEDDING_SIGNS,
  weddingSignsReprints: constants.WEDDING_SIGN_REPRINTS,
  welcomeSigns: constants.WELCOME_SIGNS,
  welcomeSignsReprints: constants.WELCOME_SIGN_REPRINTS,
  silkRibbon: constants.SILK_RIBBON,
  silkRibbonSpools: constants.SILK_RIBBON,
  ribbonSpools: constants.SILK_RIBBON,
  waxSeals: constants.WAX_SEALS,
  vellumJackets: constants.VELLUM_JACKETS,
  silkRibbonSamples: constants.SILK_RIBBON_SAMPLES,
  classicInvitationSamples: constants.CLASSIC_WEDDING_INVITATION_SAMPLES,
  letterpressInvitationSamples: constants.LETTERPRESS_WEDDING_INVITATION_SAMPLES,
  accessoriesThankYouCards: constants.ACCESSORIES_THANK_YOU_CARDS,
  componentsCards: constants.COMPONENTS_CARDS,
  doubleThickExampleCards: constants.DOUBLE_THICK_EXAMPLE_CARDS,
  envelopeLinerInserts: constants.ENVELOPE_LINER_INSERTS,
  information2018Cards: constants.INFORMATION_2018_CARDS,
  invitationThankYouCards: constants.INVITATION_THANK_YOU_CARDS,
  letterpressSampleCards: constants.LETTERPRESS_SAMPLE_CARDS,
  orderTimelineCards: constants.ORDER_TIMELINE_CARDS,
  packedByCards: constants.PACKED_BY_CARDS,
  photographyInserts: constants.PHOTOGRAPHY_INSERTS,
  ribbonInstructions: constants.RIBBON_INSTRUCTIONS,
  ribbonSampleCards: constants.RIBBON_SAMPLE_CARDS,
  ribbonSampleInstructions: constants.RIBBON_SAMPLE_INSTRUCTIONS,
  saveTheDateThankYouCards: constants.SAVE_THE_DATE_THANK_YOU_CARDS,
  standardInstructions: constants.STANDARD_INSTRUCTIONS,
  whyShineCards: constants.WHY_SHINE_CARDS,
  customColorCharts: constants.CUSTOM_COLOR_CHARTS,
  colorChartLiners: constants.COLOR_CHART_LINERS,
  colorChartKits: constants.COLOR_CHART_KITS,
  colorCharts: constants.COLOR_CHARTS,
  linerSamples: constants.LINER_SAMPLES,
  weddingPlannerBoxes: constants.WEDDING_PLANNER_BOXES,
  weddingPostponementAnnouncements: constants.WEDDING_POSTPONEMENT_ANNOUNCEMENTS
};

function applySettingsToComponentPrototype(settings) {
  // set prototype properties from settings
  var CLASSIC_LINERS = settings.linerStyles.filter(function (_ref) {
    var category = _ref.category;
    return category === 'classic';
  }).map(function (_ref2) {
    var value = _ref2.value;
    return value;
  });
  var FLORAL_LINERS = settings.linerStyles.filter(function (_ref3) {
    var category = _ref3.category;
    return category === 'floral';
  }).map(function (_ref4) {
    var value = _ref4.value;
    return value;
  });
  var LINER_COLORS = settings.colors.map(function (_ref5) {
    var value = _ref5.value;
    return value;
  });
  Object.defineProperties(Component.prototype, {
    CLASSIC_LINERS: {
      value: CLASSIC_LINERS,
      writable: true
    },
    FLORAL_LINERS: {
      value: FLORAL_LINERS,
      writable: true
    },
    LINER_COLORS: {
      value: LINER_COLORS,
      writable: true
    }
  });
  Object.keys(components).forEach(function (key) {
    var Comp = components[key];
    var weight = settings.componentWeights[key] || settings.componentWeights["default"];
    Object.defineProperty(Comp.prototype, 'COMPONENT_WEIGHT', {
      value: weight,
      writable: true
    });
  });
}

function applySettingsToProductPrototype(settings) {
  var CATALOG = settings.catalog;
  Object.defineProperties(Product.prototype, {
    CATALOG: {
      value: CATALOG,
      writable: true
    }
  });
}

module.exports = function ShineProducts() {
  var _instance;
  /**
   * ShineProducts singleton initializer
   * @param {*} opts
   * @returns {ShineProductsInstance}
   */


  function init() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
    var options = opts;
    applySettingsToComponentPrototype(options);
    applySettingsToProductPrototype(options);

    function updateOptions(newOptions) {
      options = newOptions;
      applySettingsToComponentPrototype(options);
      applySettingsToProductPrototype(options);
      return true;
    }
    /**
     * @name designStyles
     */


    function designStyles() {
      return options.designStyles;
    }
    /**
     * @name waxSealStyles
     * @param {Object} filters - key-value pairs for filtering e.g. { active: true } will return only active values
     */


    function waxSealStyles(filters) {
      var styles;

      if (filters) {
        styles = options.waxSeals.filter(function (opt) {
          return filterer(opt, filters);
        });
      } else {
        styles = options.waxSeals;
      }

      var colors = uniq(styles.map(function (_ref6) {
        var color = _ref6.color;
        return color;
      }));
      var designs = uniq(styles.map(function (_ref7) {
        var design = _ref7.design;
        return design;
      }));
      styles.colors = colors.map(function (val) {
        return {
          text: val,
          value: val
        };
      });
      styles.designs = designs.map(function (val) {
        return {
          text: val,
          value: val
        };
      });
      return styles;
    }
    /**
     * @name standardColors
     * @param {Object} filters - key-value pairs for filtering e.g. { active: true } will return only active colors
     */


    function standardColors(filters) {
      var colors = options.colors.filter(function (_ref8) {
        var classic = _ref8.classic;
        return classic;
      });

      if (filters) {
        return colors.filter(function (opt) {
          return filterer(opt, filters);
        });
      }

      return colors;
    }
    /**
     * @name envelopeAddressingColors
     * @param {Object} filters - key-value pairs for filtering e.g. { active: true } will return only active colors
     */


    function envelopeAddressingColors(envelopeColor) {
      switch (envelopeColor) {
        case 'Paper':
          return options.colors.filter(function (_ref9) {
            var value = _ref9.value;
            return ['Black', 'Navy', 'Midnight', 'Ivy', 'Smoke', 'Pecan', 'Fig', 'Cabernet'].includes(value);
          });

        case 'Cedarwood':
        case 'Chambray':
        case 'Fawn':
        case 'Granite':
        case 'Seedling':
        case 'Lagoon':
        case 'Rouge':
        case 'Malibu':
        case 'Carnation':
        case 'Terracotta':
          return options.colors.filter(function (_ref10) {
            var value = _ref10.value;
            return ['Black', 'White'].includes(value);
          });

        case 'Oyster':
          return options.colors.filter(function (_ref11) {
            var value = _ref11.value;
            return ['Black', 'Smoke', 'Navy', 'Midnight', 'Cabernet', 'Ivy', 'Pecan'].includes(value);
          });

        case 'Glacier':
          return options.colors.filter(function (_ref12) {
            var value = _ref12.value;
            return ['Black', 'White', 'Navy'].includes(value);
          });

        case 'Caviar':
        case 'Cascadia':
        case 'Clove':
        case 'Onyx':
        case 'Twilight':
        case 'Pine':
        case 'London':
        case 'Amethyst':
        case 'Claret':
        case 'Ruby':
          return options.colors.filter(function (_ref13) {
            var value = _ref13.value;
            return ['White'].includes(value);
          });

        case 'Sky':
          return options.colors.filter(function (_ref14) {
            var value = _ref14.value;
            return ['Black', 'Navy', 'Midnight'].includes(value);
          });

        case 'Limoncello':
          return options.colors.filter(function (_ref15) {
            var value = _ref15.value;
            return ['Black', 'Brass', 'Pecan'].includes(value);
          });

        case 'Mint':
          return options.colors.filter(function (_ref16) {
            var value = _ref16.value;
            return ['Black', 'Ivy'].includes(value);
          });

        case 'Almond':
        case 'Ballet':
        case 'Blossom':
          return options.colors.filter(function (_ref17) {
            var value = _ref17.value;
            return ['Black', 'Cabernet'].includes(value);
          });

        case 'Opal':
          return options.colors.filter(function (_ref18) {
            var value = _ref18.value;
            return ['Black', 'Smoke', 'Navy', 'Midnight', 'Cabernet', 'Ivy', 'Pecan'].includes(value);
          });

        default:
          return options.colors.filter(function (_ref19) {
            var value = _ref19.value;
            return ['Black'].includes(value);
          });
      }
    }
    /**
     * @name letterpressColors
     * @param {Object} filters - key-value pairs for filtering e.g. { active: true } will return only active colors
     */


    function letterpressColors(filters) {
      var colors = options.colors.filter(function (_ref20) {
        var letterpress = _ref20.letterpress;
        return letterpress;
      });

      if (filters) {
        return colors.filter(function (opt) {
          return filterer(opt, filters);
        });
      }

      return colors;
    }
    /**
     * @name allColors
     * @param {Object} filters - key-value pairs for filtering e.g. { active: true } will return only active colors
     */


    function allColors(filters) {
      var colors = options.colors;

      if (filters) {
        return colors.filter(function (opt) {
          return filterer(opt, filters);
        });
      }

      return colors;
    }
    /**
     * @name linerStyles
     * @param {Object} filters - key-value pairs for filtering e.g. { category: 'classic', active: true } will return only active liners with category = 'classic'
     */


    function linerStyles(filters) {
      if (filters) {
        return options.linerStyles.filter(function (opt) {
          return filterer(opt, filters);
        });
      }

      return options.linerStyles;
    }
    /**
     * @name paperTypes
     * @param {Object} filters - key-value pairs for filtering e.g. { category: 'letterpress', active: true } will return only active paper types with category = 'letterpress'
     */


    function paperTypes(filters) {
      if (filters) {
        return options.paperTypes.filter(function (opt) {
          return filterer(opt, filters);
        });
      }

      return options.paperTypes;
    }
    /**
     * @name floralBellyBands
     * @param {Object} filters - key-value pairs for filtering e.g. { active: true } will return only active ribbon colors
     */


    function floralBellyBands(filters) {
      if (filters) {
        return options.floralBellyBands.filter(function (opt) {
          return filterer(opt, filters);
        });
      }

      return options.floralBellyBands;
    }
    /**
     * @name ribbonColors
     * @param {Object} filters - key-value pairs for filtering e.g. { active: true } will return only active ribbon colors
     */


    function ribbonColors(filters) {
      if (filters) {
        return options.ribbonColors.filter(function (opt) {
          return filterer(opt, filters);
        });
      }

      return options.ribbonColors;
    }
    /**
     * @name componentSizes
     * @param component_name - optional - e.g. FavorTag
     */


    function componentSizes(component_name) {
      if (component_name) {
        return options.componentSizes[component_name] || [];
      }

      return options.componentSizes;
    }
    /**
     * @name componentQuantities
     * @param component_name - optional - e.g. FavorTag
     */


    function componentQuantities(component_name, reprint) {
      if (component_name) {
        var quantity_options = reprint ? options.reprintComponentQuantities : options.componentQuantities;
        var component_quantity_options = quantity_options[component_name] || quantity_options["default"];
        return generateQuantityOptions(component_quantity_options);
      }

      return options.componentQuantities;
    }
    /**
     * @name make
     * @returns {Product}
     */


    function _make(params) {
      var product_type = params.product_type;
      var Constructor = getMatchingConstructor(product_type);

      if (typeof Constructor !== 'function') {
        throw new Error("".concat(product_type, " did not match a constructor"));
      }

      var product = new Constructor(params);
      product.setComponentCollections(params);
      product.setPriceTableVersions(params);
      return product;
    }

    var reprints = {
      make: function makeReprints(params) {
        var possible_product_type = params.product_type.replace(/s$/, ' Reprints');
        var product_type;

        if (Object.values(constants).includes(possible_product_type)) {
          product_type = possible_product_type;
        } else {
          product_type = params.product_type;
        }

        return _make(Object.assign(JSON.parse(JSON.stringify(params)), {
          product_type: product_type
        }));
      }
    };

    function convertProduct(product, product_type) {
      var newProduct = _make(JSON.parse(JSON.stringify(product)));

      handleConvertProduct(newProduct, product_type, options);
      newProduct.product_type = product_type;
      return _make(newProduct);
    }
    /**
     * @param {Product} product - the Product whose properties you wish to extract
     * @param {String} formatter - name of formatter, must be included in module options
     * @returns {Array}
     */


    function propertiesOf(product) {
      var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      return extractProperties(product, options.formatters, formatter);
    }

    function personalizationFields(product) {
      return options.personalization[product.type] || [];
    }

    function convert(product, version) {
      if (version === 0) {
        var params = _objectSpread(_objectSpread(_objectSpread({}, product), product.attr), product.pers);

        delete params.attr;
        delete params.pers;
        return convertFromVersionZero(this, params, options);
      }

      throw new Error("version must be 0, 1 has been deprecated. received ".concat(version));
    }

    function fromEtsyTransaction(transaction, receipt) {
      var product_type = parseProductTypeFromEtsyTransaction(transaction.title);

      var product = _make({
        product_type: product_type
      }); // if this is a deposit (invitation suite or other customizable stationery),
      // this will return false. In that case, we want to run the standard .defaults() method


      createShineProductFromEtsyTransaction.call(product, transaction, receipt, options);
      return product;
    }

    function parcelPostRequired(product, otherProductTypes) {
      return parcelPostRequiredFn(product, otherProductTypes, constants);
    }

    function oddPostageRequired(product, otherProductTypes) {
      return oddPostageRequiredFn(product, otherProductTypes, constants);
    }

    function placeCardStyles() {
      return options.placeCardStyles;
    }

    function mealIndicators() {
      return options.mealIndicators;
    }

    function getProductCategory(product) {
      var product_type = product.product_type;
      var cat = '';
      Object.keys(categories).forEach(function (category) {
        if (Object.values(categories[category]).includes(product_type)) {
          cat = category;
        }
      });
      return cat;
    }

    var fns = {
      make: _make,
      constants: constants,
      updateOptions: updateOptions,
      designStyles: designStyles,
      standardColors: standardColors,
      envelopeAddressingColors: envelopeAddressingColors,
      linerStyles: linerStyles,
      paperTypes: paperTypes,
      letterpressColors: letterpressColors,
      allColors: allColors,
      ribbonColors: ribbonColors,
      componentSizes: componentSizes,
      componentQuantities: componentQuantities,
      waxSealStyles: waxSealStyles,
      floralBellyBands: floralBellyBands,
      constructors: constructors,
      propertiesOf: propertiesOf,
      personalizationFields: personalizationFields,
      convert: convert,
      convertProduct: convertProduct,
      getProductCategory: getProductCategory,
      reprints: reprints,
      parcelPostRequired: parcelPostRequired,
      oddPostageRequired: oddPostageRequired,
      migrate: convert,
      extractProperties: propertiesOf,
      // alias
      productProperties: propertiesOf,
      // alias
      fromEtsyTransaction: fromEtsyTransaction,
      placeCardStyles: placeCardStyles,
      mealIndicators: mealIndicators
    }; // assign all the shortcut make() methods to `fns`
    // e.g. ShineProducts.classicInvitationSuite.make()

    Object.keys(constructors).forEach(function (name) {
      fns[name] = {
        make: function make(params) {
          return _make(_objectSpread(_objectSpread({}, params), {}, {
            product_type: constructors[name]
          }));
        }
      };
    });
    return fns;
  }

  return {
    /**
     * initialize
     * @param {*} opts
     * @instance
     * @example
     * import { ShineProducts } from 'shine-products-v2';
     * ShineProducts.initialize(opts);
     */
    initialize: function initialize(opts) {
      _instance = init(opts);
    },

    /**
     * SINGLETON INSTANCE
     * @instance
     * @example
     * import { ShineProducts } from 'shine-products-v2';
     * ShineProducts.instance()
     * @returns {ShineProductsInstance}
     */
    instance: function instance() {
      if (!_instance) {
        throw new Error('You must first initialize');
      }

      return _instance;
    }
  };
}();